import React, { createContext, useContext } from 'react';
import type { IMatchScheduleItem } from '../../../../../types/schedule';

export type SchedulePlacementActionsContextValue = {
  swapModifierHeld: boolean;
  swapContextActive: boolean;
  activePlacementMatchId: number | null;
  focusedSwapTargetMatchId: number | null;
  onSwapWithScheduledMatch?: (target: IMatchScheduleItem) => void | Promise<void>;
  onSelectGridMatchForPlacement?: (matchId: number) => void;
  placementDragDisabled: boolean;
  dragModifierBlocked: boolean;
  scheduleMutationBlocked: boolean;
};

export type SchedulePlacementSelectionContextValue = {
  selectedGridMatchId: number | null;
};

/** @deprecated Use split actions/selection contexts */
export type SchedulePlacementContextValue = SchedulePlacementActionsContextValue & {
  pendingPlaceMatchId: number | null;
  pendingPlacementSource: 'unscheduled' | 'scheduled_grid' | null;
  placeModeActive: boolean;
};

const SchedulePlacementActionsContext =
  createContext<SchedulePlacementActionsContextValue | null>(null);

const SchedulePlacementSelectionContext =
  createContext<SchedulePlacementSelectionContextValue | null>(null);

const SchedulePlacementContext = createContext<SchedulePlacementContextValue | null>(null);

export const SchedulePlacementActionsProvider = ({
  value,
  children,
}: {
  value: SchedulePlacementActionsContextValue;
  children: React.ReactNode;
}) => (
  <SchedulePlacementActionsContext.Provider value={value}>
    {children}
  </SchedulePlacementActionsContext.Provider>
);

export const SchedulePlacementSelectionProvider = ({
  value,
  children,
}: {
  value: SchedulePlacementSelectionContextValue;
  children: React.ReactNode;
}) => (
  <SchedulePlacementSelectionContext.Provider value={value}>
    {children}
  </SchedulePlacementSelectionContext.Provider>
);

/** @deprecated Use SchedulePlacementActionsProvider + SchedulePlacementSelectionProvider */
export const SchedulePlacementProvider = ({
  value,
  children,
}: {
  value: SchedulePlacementContextValue;
  children: React.ReactNode;
}) => (
  <SchedulePlacementContext.Provider value={value}>{children}</SchedulePlacementContext.Provider>
);

export const useSchedulePlacementActionsContext = (): SchedulePlacementActionsContextValue | null =>
  useContext(SchedulePlacementActionsContext);

export const useSchedulePlacementSelectionContext =
  (): SchedulePlacementSelectionContextValue | null =>
    useContext(SchedulePlacementSelectionContext);

export const useSchedulePlacementContext = (): SchedulePlacementContextValue | null =>
  useContext(SchedulePlacementContext);
